//=require DW.ScrollAnimationItem.js

DW.TimelineElement = function(container) {
	this.container = container;
	this.image = container.querySelector("img");
};

// Extend ScrollAnimation Item
extendObj(DW.TimelineElement, DW.ScrollAnimationItem);

DW.TimelineElement.prototype.animateWhileInView = function(scrollPos, height) {

	// Only on larger screens
	if(window.matchMedia("(min-width: 48em)").matches) {
		var ratioScrolled;
		var rect = this.container.getBoundingClientRect();
		var rectHeight = this.container.offsetHeight;
		var heightHalf = ((rect.bottom - rect.top) / 2);
		var scaleMaxFactor = 1.1;
		var scaleChangeFactor = 0.5;
		// console.log("Full scroll", (height - rect.top) / height);
		// console.log("Half scroll", (height - rect.top) / (height / 2));

		// console.log(rectHeight);
		if(rect.top + heightHalf > height / 2) {
			// lower half

			ratioScrolled = Math.min(1, (height - rect.top - heightHalf) / (height / 2));
			prefix(this.container, 'transform', 'scale(' + (scaleMaxFactor - (scaleChangeFactor - scaleChangeFactor * ratioScrolled)) + ')');
		} else {

			ratioScrolled = Math.min(1, ((height - rect.top - heightHalf) / (height / 2) - 1));
			prefix(this.container, 'transform', 'scale(' + (scaleMaxFactor - scaleChangeFactor * ratioScrolled) + ')');
		}
	} else {
		prefix(this.container, 'transform', 'scale(1)');
	}
};
